import { useRouter } from 'next/router'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

import * as S from './styles'
import { useFeaturedArticle } from './useFeaturedArticle'
import { Image, Text, Tooltip } from '@/components'
import { Article } from '@/service/api/blog'

export type FeaturedArticleProps = {
  data: Article
}
export const FeaturedArticleContainer: React.FC<FeaturedArticleProps> = ({
  data,
}) => {
  const { fontSizes } = useFeaturedArticle()
  const router = useRouter()

  const handleClick = (slug: string) => {
    router.push(`/blog/${slug}`)
  }

  return (
    <S.FeaturedArticleContainer onClick={() => handleClick(data.slug)}>
      <div className="linear-gradient" />

      <div className="article">
        <Text size={fontSizes.title} align="left" className="title">
          {data.title}
          <Tooltip text={data.title} />
        </Text>
        <div className="tags">
          {data.tags.map((tag) => (
            <Text key={tag} size="b4" className="tag">
              {tag}
            </Text>
          ))}
        </div>

        <ReactMarkdown className="description">{data.excerpt}</ReactMarkdown>
      </div>
      <div className="image-container">
        <Image
          src={data.src}
          alt={data.alt}
          fileName={data.fileName}
          fill
          style={{ zIndex: -10, objectFit: 'cover' }}
          priority
        />
      </div>
    </S.FeaturedArticleContainer>
  )
}
